import { render, staticRenderFns } from "./CrowdIcon.vue?vue&type=template&id=ff8228de"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff8228de')) {
      api.createRecord('ff8228de', component.options)
    } else {
      api.reload('ff8228de', component.options)
    }
    module.hot.accept("./CrowdIcon.vue?vue&type=template&id=ff8228de", function () {
      api.rerender('ff8228de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CrowdIcon.vue"
export default component.exports